<template>
  <div>
    <div v-if="order.status != 30 && groupOrderLine && groupOrderLine[0].status != 3">
      <!-- <div v-if="order.status == 12">
        <el-button @click="editOrder()" style="margin-bottom: 10px;" class="block btn-14">修改任务</el-button>
      </div> -->
      <!-- <div v-if="order.status == 11">
        <el-button :loading="loading" @click="take_by_single()" type="info" style="margin-bottom: 10px;" class="block btn-14">确认接单</el-button>
        <el-dialog width="30%" :close-on-click-modal="false" :visible.sync="offline" @close="offLine = false">
          <h1 style="text-align:center; padding: 0 0 30px;">提示</h1>
          <p>此下单任务为私下支付, 请确认收到付款再下单</p>
          <div slot="footer" class="dialog-footer" style="margin-top:10px;">
            <el-button @click="offline = false">取消</el-button>
            <el-button type="primary" @click="Submit()">确认</el-button>
          </div>
        </el-dialog>
      </div> -->
      <!-- <div v-if="order.status == 13">
        <el-button :loading="loading" @click="begin()" type="info" style="margin-bottom: 10px;" class="block btn-14">开始下单</el-button>
      </div> -->
      <!-- <div v-if="order.status == 14 && groupOrderLine[0].status == 0">
        <UploadOrderDialog style="display:block;" :order="order" :mobiletype="mobiletype" :groupOrderLine="groupOrderLine" v-on:complete="complete">
          <el-button type="info" style="margin-bottom: 10px;" class="block btn-14">上传下单信息</el-button>
        </UploadOrderDialog>
      </div> -->
      <!-- <div v-if="['1', '4','5','6'].indexOf(groupOrderLine[0].status) > -1">
          <OrderVoucher :groupOrderLine="groupOrderLine" :isSingle="isSingle" :mobiletype="mobiletype" :order="order" style="display:block;">
            <el-button class="block btn-14" type="info">下单凭证</el-button>
          </OrderVoucher>
      </div>
      <div v-if="groupOrderLine[0].status == 2" class="text">
          <OrderVoucher :groupOrderLine="groupOrderLine" :isSingle="isSingle" :mobiletype="mobiletype" :order="order" style="display:block;">
            <el-button class="block btn-14" >下单凭证</el-button>
          </OrderVoucher>
      </div> -->
      <!--待发货-->
      <!-- <div v-if="order.status == 15 && groupOrderLine[0].status == 1">
        <UploadExpressDialog style="display:block;margin-top: 10px;" :order="order" :mobiletype="mobiletype" :groupOrderLine="groupOrderLine" v-on:complete="complete">
          <el-button type="info" style="margin-bottom: 10px;" class="block btn-14">上传发货信息</el-button>
        </UploadExpressDialog>
      </div> -->
      <!--待发货-->
      <OrderTrackDialog :normal_address_show="normal_address_show" :shippingArr="shippingArr" :groupOrderLine="groupOrderLine" @updateGroupLine="updateGroupLine" v-if="(groupOrderLine[0].status == 4 || groupOrderLine[0].status == 5 || groupOrderLine[0].status == 6)" :mobiletype="mobiletype" :packageId="packageId" :order="order" :isSingle="isSingle" style="display:block;">
        <el-button class="block btn-14" type="info">包裹跟踪</el-button>
      </OrderTrackDialog>
      <template v-if="order.transport_express_id!=1553">
        <OrderTransportApply @complete="completeTransportApply" v-if="order.service_type==2 && groupOrderLine[0].status == 4 && groupOrderLine[0].transport_status==1 && zhuanyun_role_enable" :totalAccountList="totalAccountList" :groupOrderLine="groupOrderLine" :mobiletype="mobiletype" :order="order" :isSingle="isSingle" style="display:block;margin-top: 10px;">
          <el-button class="block btn-14 nohover">包裹申报</el-button>
        </OrderTransportApply>
      </template>
      <OrderTransportApplyWanshan @complete="completeTransportApply" v-if="order.service_type==2 && groupOrderLine[0].transport_status==11 && zhuanyun_role_enable" :totalAccountList="totalAccountList" :groupOrderLine="groupOrderLine" :mobiletype="mobiletype" :order="order" :isSingle="isSingle" style="display:block;margin-top: 10px;">
        <el-button class="block btn-14 nohover">完善申报</el-button>
      </OrderTransportApplyWanshan>
      <template>
        <OrderTransportApplyChuku @complete="completeTransportApply" v-if="order.service_type==2 && groupOrderLine[0].status == 4 && groupOrderLine[0].transport_status==3 && zhuanyun_role_enable" :totalAccountList="totalAccountList" :groupOrderLine="groupOrderLine" :mobiletype="mobiletype" :order="order" :isSingle="isSingle" style="display:block;margin-top: 10px;">
          <el-button class="block btn-14 nohover">提交出库</el-button>
        </OrderTransportApplyChuku>
      </template>
      <!-- <ProductCancelDialog v-on:lineChange="lineChange" v-on:complete="complete" v-if="order.status != 13 && order.status != 12 && order.status != 11 && ['0', '1', '4','5','6'].indexOf(groupOrderLine[0].status) > -1" style="display:block;margin-top: 10px;" :mobiletype="mobiletype" :order="order" :groupOrderLine="groupOrderLine">
        <el-button style="margin-bottom: 10px;" class="block btn-14">取消商品</el-button>
      </ProductCancelDialog> -->
      <!-- <OrderCancelDialog v-if="['11','12', '13'].indexOf(order.status) > -1" :mobiletype="mobiletype" :isSingle="isSingle" :order="order" style="display:block;" v-on:complete="complete">
        <el-button style="margin-bottom: 10px;" :loading="loading" class="block btn-14">取消任务</el-button>
      </OrderCancelDialog> -->
      <OrderShare :order="order" style="display:block;" :mobiletype="mobiletype" v-if="order.status == 12">
        <el-button style="margin-bottom: 10px;" :loading="loading" class="block btn-14">分享任务</el-button>
      </OrderShare>
    </div>
    
  </div>
</template>

<script>
import OrderCancelDialog from '../OrderCancelDialog'
import UploadOrderDialog from './UploadOrderDialog'
import UploadExpressDialog from './UploadExpressDialog'
import ProductCancelDialog from './ProductCancelDialog'
import OrderTrackDialog from '../OrderTrackDialog'
import OrderTransportApply from '../OrderTransportApply'
import OrderTransportApplyWanshan from '../OrderTransportApplyWanshan.vue'
import OrderTransportApplyChuku from '../OrderTransportApplyChuku'
import OrderVoucher  from '../OrderVoucher'
import OrderShare from '../OrderShare'
import api from '../../../../services/api.js'
import {API_HOST} from '../../../../services/constant.js'

export default {
  name: 'OrderList',
  props: ['order', 'packageId', 'groupOrderLine', 'isSingle','mobiletype','shippingArr'
  ,'normal_address_show','zhuanyun_role_enable','totalAccountList'],
  components: {
    OrderCancelDialog: OrderCancelDialog,
    UploadOrderDialog: UploadOrderDialog,
    ProductCancelDialog: ProductCancelDialog,
    UploadExpressDialog: UploadExpressDialog,
    OrderTrackDialog: OrderTrackDialog,
    OrderTransportApply:OrderTransportApply,
    OrderTransportApplyChuku:OrderTransportApplyChuku,
    OrderTransportApplyWanshan:OrderTransportApplyWanshan,
    OrderVoucher: OrderVoucher,
    OrderShare: OrderShare
  },
  computed: {
    taskInfo () {
	    return this.$store.state.taskInfo
    }
  },
  data () {
    return {
      loading: false,
      completion: false,
      status: null,
      operationType: '', //操作类别
      type: '',//商品or任务
      refund: '',//退款
      offline: false,//线下支付弹框
      isOffLine: false,//是否线下支付
    }
  },
  created() {
    console.log('sss',this.normal_address_show)
  },
  methods: {
    editOrder () {
      this.$store.commit('clearTaskInfo')
      this.$localStorage.set('goBackOrderUrl', this.$route.fullPath)
      this.$router.push({ path: '/buyer/publish_task/confirm', query:{order_id: this.order.id} })
    },
    updateGroupLine(data){
      this.$emit('updateGroupLine',data)
    },
    completeTransportApply(data){
      this.$emit('complete',data)
    },
    lineChange () {
      this.$emit('lineChange')
    },
    async take_by_single () {
      if(!this.isOffLine) {
        if(this.order.offline_payment == '1'){
          this.offline = true
          this.$forceUpdate()
          return
        }
      }
      let res = await api.post(this, {
        path: 'order.php',
        api: 'take_by_single',
        data: {
          order_id: this.order.id,
          update_time: this.order.update_time
        },
        loading: 'loading'
      })
      res = res.body
      if (res.status == 'ok') {
        this.order.status = '13'
        this.order.update_time = res.result.update_time
        this.order.take_time = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        console.log('this.order.take_timethis.order.take_time', this.order.take_time)
        console.log(this.order)
      }
      this.$emit('lineChange')
    },
    Submit () {
      this.offline = false
      this.isOffLine = true
      this.take_by_single()
    },
    async begin () {
      let res = await api.post(this, {
        path: 'order.php',
        api: 'begin',
        data: {
          order_id: this.order.id,
          update_time: this.order.update_time
        },
        loading: 'loading'
      })
      res = res.body
      if (res.status == 'ok') {
        this.order.status = '14'
        this.order.update_time = res.result.update_time
      }
      this.$emit('lineChange')
    },
    complete (data){
      this.$emit('complete', data)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
// .isMobile{
//   display: none;
// }
//   @media screen and (max-width: 1024px) {
//     .isMobile{
//       display: block;
//     }
//   }

</style>



// WEBPACK FOOTER //
// src/pages/orders/list/single/OrderOperation.vue